import React from 'react'
import utils from '../../Utils'
// import StarRatingComponent from 'react-star-rating-component';
import RateBox from './RateBox'
// import StarRoundedIcon from '@material-ui/icons/StarRounded';
// import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';

const DoctorListItem = ({ handleClick, doctor }) => {
    const formatMoney = (price) => (parseInt(price)).toLocaleString("fa-IR", { minimumFractionDigits: 0 })

    return (
        <div className="doctor-info card" onClick={handleClick} >
            <div className="doctor-avatar">
                {doctor.url ?
                    <img src={utils.urls.image + doctor.url} alt={doctor.url} /> :
                    <img src="/images/person.svg" />
                }
            </div>
            <div className="doctor-description">
                <div className="description__name">
                    <div className="name">{`${doctor.fname} ${doctor.lname}`}</div>
                    <div className="experty" style={{ fontSize: '10px' }}>
                        {doctor.expUnis[0] && 'فوق تخصص ' + doctor.expUnis[0].expertise.name}
                    </div>
                    <div className="experty" style={{ fontSize: '10px' }}>
                        {doctor.spUnis[0] && 'متخصص ' + doctor.spUnis[0].specialty.name}
                    </div>
                    <div className="experty" style={{ fontSize: '10px' }}>
                        {(!doctor.spUnis[0] && !doctor.expUnis[0]) && 'پزشک عمومی'}
                    </div>
                    <div className="avg-response">میانگین زمان پاسخ دهی: <span className="rate">{doctor.DoctorConsultInfo.avgResponse.toLocaleString("fa-IR")} ساعت</span></div>
                </div>
                <RateBox rateItem={doctor.rateItem} price={formatMoney(doctor.DoctorConsultInfo.price)} />
            </div>
        </div>
    )
}

export default DoctorListItem
